import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles, Settings2, ShoppingBag } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Sparkles className="w-8 h-8 text-white" data-id="element-134" />,
    title: 'Generas',
    desc: 'Usas nuestros prompts probados para crear colecciones de arte en segundos.',
    color: 'bg-lavender'
  }, {
    icon: <Settings2 className="w-8 h-8 text-white" data-id="element-135" />,
    title: 'Optimizas',
    desc: 'Sigues nuestra guía para convertir esa imagen en un archivo digital de alta calidad.',
    color: 'bg-softBlue'
  }, {
    icon: <ShoppingBag className="w-8 h-8 text-white" data-id="element-136" />,
    title: 'Vendes',
    desc: 'Publicas en plataformas automáticas y dejas que el sistema trabaje por ti.',
    color: 'bg-peach'
  }];
  return <section className="py-16 md:py-24 bg-white px-4 sm:px-6 lg:px-8" data-id="element-137">
      <div className="max-w-5xl mx-auto" data-id="element-138">
        <FadeIn data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-darkText mb-16" data-id="element-140">
            Cómo funciona el sistema
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-141">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-cream -z-10" data-id="element-142"></div>

          {steps.map((step, idx) => <FadeIn key={idx} delay={idx * 0.2} data-id="element-143">
              <div className="flex flex-col items-center text-center" data-id="element-144">
                <div className={`w-24 h-24 rounded-full ${step.color} flex items-center justify-center shadow-lg mb-6 border-4 border-white`} data-id="element-145">
                  {step.icon}
                </div>
                <h3 className="text-2xl font-heading font-bold text-darkText mb-4" data-id="element-146">
                  {step.title}
                </h3>
                <p className="text-lightText leading-relaxed" data-id="element-147">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}